import { env } from '../../app/utils';
import { minifiedLibHost } from '../../shared/constants/urls';
import { injectScript } from '../../shared/injectScript';

import delay from 'lodash/delay';
import { rgIDs } from '../../shared/constants/domIDs';
import { Container, Coords } from '../../shared/interfaces';
import {
  cssNamespace,
  isButton,
  isFixed,
  isRelative,
} from '../../shared/styles';
import { attachToNode, createFrame } from '../utils/builder';
import {
  DEFAULT_SPACING,
  DEFAULT_SPACING_BOTTOM,
  Magnetize,
} from '../utils/magnetize';
import './styles.scss';
import { MagnetizeElise } from '../utils/magnetize-elise';

class RGMessenger extends Container {
  config: any;
  elId: string;
  element: HTMLDivElement;
  private magnetize: Magnetize | null = null;

  constructor() {
    super();

    this.config = {};
    this.elId = rgIDs.messenger;
    this.element = null;
  }

  onShow() {
    this.element.style.display = 'none';
  }

  onHide() {}

  onTooltipDisplay(coords: Coords) {}

  onOpen() {
    this.element.classList.add('is-show');
  }

  onClose() {
    this.element.classList.remove('is-show');
  }

  onToggle() {
    this.element.classList.toggle('is-show');
  }

  addClass(className: string) {
    this.element.classList.add(className);
  }

  setPosition(position: 'left' | 'right') {
    this.addClass(position);
  }

  setRenderStyle(style: string) {
    const className = `${cssNamespace}${style}`;

    this.addClass(className);
  }

  setZIndex() {}

  setMargins() {
    const onMobileResponsive = (m: MediaQueryListEvent | MediaQueryList) => {
      if (m.matches) {
        this.element.style[this.config.position] = '0';
        this.element.style.bottom = '0';
      } else {
        this.element.style[this.config.position] = '10px';
        this.element.style.bottom = '10px';
      }
    };

    const matchMobile = window.matchMedia('(max-width: 720px)');

    onMobileResponsive(matchMobile);

    matchMobile.addEventListener('change', onMobileResponsive);
  }

  async render(config): Promise<void> {
    return new Promise(async (resolve, reject) => {
      this.config = config;

      try {
        this.element = await createFrame(this.elId);

        this.setRenderStyle(config.renderAs);

        if (isFixed(config.renderAs) || isButton(config.renderAs)) {
          this.setPosition(config.position);
          this.setMargins();
        }

        if (isRelative(config.renderAs)) {
          attachToNode(rgIDs.relativeNode, this.element);
        }

        await injectScript(
          `${minifiedLibHost[env.environment]}/rg-messenger-init.min.js`,
          ''
        );
        window.RGMessengerComponent.render(config, this.elId);

        if (config.syncEliseAI) {
          const targetNode = document.body;

          const observerConfig = {
            attributes: true,
            childList: true,
            subtree: true,
          };

          const callback = (_, observer) => {
            const eliseAiWidgetElement = MagnetizeElise.getEliseElement();

            if (eliseAiWidgetElement) {
              observer.disconnect();

              this.magnetize = new MagnetizeElise(
                this.element,
                {
                  bottom: config.screen.isMobile ? 0 : DEFAULT_SPACING_BOTTOM,
                  left: 0,
                  right: 0,
                },
                {
                  absoluteBottom: config.screen.isMobile ? 0 : DEFAULT_SPACING,
                  horizontalPadding: config.screen.isMobile
                    ? 0
                    : DEFAULT_SPACING,
                }
              );
            }
          };

          const observer = new MutationObserver(callback);

          observer.observe(targetNode, observerConfig);
        } else {
          this.magnetize = new Magnetize(
            document.getElementById('onetrust-banner-sdk'),
            this.element,
            {
              bottom: this.config.marginY,
            }
          );
        }

        this.magnetize.init();
        delay(resolve, 1000, true);
      } catch (error) {
        reject(false);
      }
    });
  }

  unmount() {
    if (this.magnetize) {
      this.magnetize.cleanup();
      this.magnetize = null;
    }

    if (this.element?.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
  }
}

window.RGMessenger = new RGMessenger();
